
import React from 'react';
import { Link } from 'react-router-dom';
import { ArrowRight, MapPin, Clock } from 'lucide-react';

const ContactSection = () => {
  return (
    <section className="py-16 bg-white">
      <div className="container mx-auto px-4">
        <div className="text-center">
          <h2 className="text-3xl font-bold text-fabre-gray mb-4">
            Contactez-nous pour une estimation gratuite
          </h2>
          <p className="text-gray-600 mb-8 max-w-2xl mx-auto">
            Nos experts sont à votre disposition pour évaluer vos métaux et vous proposer 
            les meilleurs prix. Estimation gratuite et sans engagement.
          </p>
          <div className="flex flex-col sm:flex-row gap-4 justify-center">
            <Link to="/contact" className="inline-flex items-center bg-red-600 hover:bg-red-700 text-white font-bold py-3 px-6 rounded transition-colors">
              Demander un devis 
              <ArrowRight className="ml-2 h-5 w-5" />
            </Link>
          </div>
          
          <div className="mt-8 grid grid-cols-1 md:grid-cols-3 gap-6 max-w-4xl mx-auto">
            <div className="text-center">
              <MapPin className="h-8 w-8 text-red-600 mx-auto mb-2" />
              <div className="font-bold">9 zones d'expertise</div>
              <div className="text-sm text-gray-600">Occitanie & Île-de-France</div>
            </div>
            <div className="text-center">
              <Clock className="h-8 w-8 text-red-600 mx-auto mb-2" />
              <div className="font-bold">Intervention 48h</div>
              <div className="text-sm text-gray-600">Service rapide garanti</div>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
};

export default ContactSection;
